import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import "../styles/UserSearchAutocomplete.css";

const UserSearchAutocomplete = ({ chatClient, currentUserId, onUserSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchTerm.length < 3) {
      setSuggestions([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const delayDebounce = setTimeout(async () => {
      try {
          const response = await chatClient.queryUsers(
              { name: { $autocomplete: searchTerm }, id: { $ne: currentUserId }, share: true },
          { id: 1 },
          { limit: 5 }
        );

        setSuggestions(response.users);
      } catch (error) {
          console.error("Error fetching users:", error);
          setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, chatClient, currentUserId]);

  const handleSelect = (user) => {
    setSuggestions([]);
    setSearchTerm("");
    onUserSelect(user);
  };

  return (
    <div className="autocomplete-container">
      <div className="input-with-spinner">
        <Input
          type="text"
          value={searchTerm}
          placeholder="Search users..."
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {loading && <div className="spinner" />}
      </div>

      {suggestions.length > 0 && (
        <ul className="autocomplete-suggestions">
          {suggestions.map((user) => (
            <li key={user.id} className="autocomplete-user" onClick={() => handleSelect(user)}>
              <div className="avatar">
                {user.photo ? (
                  <img src={user.photo} alt={user.name} />
                ) : (
                  <div className="initials-circle">
                    {user.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .toUpperCase()
                      .slice(0, 2)}
                  </div>
                )}
              </div>
              <div className="user-info">
                <div className="user-name">{user.name}</div>
                <div className="user-org">{user.organization || "No organization"}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserSearchAutocomplete;
